import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import cx from 'classnames';
import * as React from 'react';

import styles from './EtazhiBlackFridayPromoOffersLayout.css';

interface IEtazhiBlackFridayPromoOffersLayoutProps {
  carousel: React.ReactNode;
  card: React.ReactNode;
  offersViewed: boolean;
  onPromoOffersShown: VoidFunction;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const EtazhiBlackFridayPromoOffersLayout: React.FC<IEtazhiBlackFridayPromoOffersLayoutProps> = props => {
  const { carousel, card, offersViewed, onPromoOffersShown } = props;

  return (
    <ActionAfterViewObserver callback={onPromoOffersShown} triggerOnce>
      <div
        className={cx(styles['container'], offersViewed && styles['carousel-offers-viewed'])}
        data-testid="EtazhiBlackFridayPromoOffersLayout"
      >
        <div className={styles['card']}>{card}</div>
        <div className={styles['carousel']}>{carousel}</div>
      </div>
    </ActionAfterViewObserver>
  );
};
